import { BaseSecuredApi } from "./BaseSecuredApi";

class AccountStatus extends BaseSecuredApi {
  constructor() {
    super("AccountStatus");
  }

  getManagementFees(accountId) {
    return this.POST({
      action: "getManagementFees",
      data: {
        accountId,
      },
      cache: true,
      cacheKey: accountId,
    });
  }
  getStatus(accountId, year) {
    return this.POST({
      action: "getStatus",
      data: {
        accountId,
        year: year,
      },
      cache: true,
      cacheKey: accountId + "_" + year,
    });
  }
  getFundDetails(accountId) {
    return this.POST({
      action: "getFundDetails",
      data: {
        accountId,
      },
      cache: true,
      cacheKey: accountId,
    });
  }
  getTransactions(data) {
    return this.POST({
      action: "getTransactions",
      data,
    });
  }
  getEmployeeDepositCompare(data) {
    return this.POST({
      action: "EmployeeDepositCompare",
      data,
    });
  }
  getEmployeePaymentClassification(data) {
    return this.POST({
      action: "EmployeeDepositPaymentComponents",
      data,
    });
  }

  exportExcelDepositCompare(data) {
    return this.POST({
      action: "EmployeeDepositCompareExcel",
      data,
    })
      .then((res) => {
        if (res.downloadUrl) {
          res.downloadUrl = BaseSecuredApi.baseApiUrl + res.downloadUrl;
          return res;
        }
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  }

  exportExcelPaymentComponents(data) {
    return this.POST({
      action: "EmployeeDepositPaymentComponentsExcel",
      data,
    })
      .then((res) => {
        if (res.downloadUrl) {
          res.downloadUrl = BaseSecuredApi.baseApiUrl + res.downloadUrl;
          return res;
        }
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  }
}

export const AccountStatusApi = new AccountStatus();
